module.exports = __webpack_public_path__ + "static/media/window-close.06d8ab6b.svg";